module.exports = __webpack_public_path__ + "img/delivery-animation.cc593d8f.svg";